// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SubscribedPhotoblogs":"tb_a bhs_b bhs_bj","SubscribedPhotoblogs__link":"tb_b bhs_a bhs_r"};